import styles from "./StudentForms.module.css";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";

import IconAndName from "../../components/IconAndName/IconAndName";
import { IoAddCircleOutline } from "react-icons/io5";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import Action from "../../components/Action/Action";
import { useNavigate } from "react-router-dom";

import { RiFileTextLine } from "react-icons/ri";
import CopyRight from "../../components/CopyRight/CopyRight";

const data = [
  {
    _id: "1",
    title: "Agreement 1",
    date: "05/06/2025",
    status: "Live",
    submission: 0,
    review: 0,
    actions: ["Edit", "Duplicate", "Delete"],
  },
  {
    _id: "2fnhygrbgjmygnhrgbrt54t54egr",
    title: "Agreement 1",
    date: "05/06/2025",
    status: "Live",
    submission: 0,
    review: 0,
    actions: ["Edit", "Duplicate", "Delete"],
  },
  {
    _id: "3",
    title: "Agreement 1",
    date: "05/06/2025",
    status: "Live",
    submission: 0,
    review: 0,
    actions: ["Edit", "Duplicate", "Delete"],
  },
  {
    _id: "4",
    title: "Agreement 1",
    date: "05/06/2025",
    status: "Live",
    submission: 0,
    review: 0,
    actions: ["Edit", "Duplicate", "Delete"],
  },
];

function StudentForms() {
  const dispatch = useDispatch();
  const [selectedIds, setSelectedIds] = useState([]);
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds((prev) =>
                checked
                  ? [...prev, item._id]
                  : prev.filter((id) => id !== item._id)
              );
            }}
          />
        ),
        
        title: (
          <div
            className={styles.titleCell}
            onClick={() => navigate(`/forms/student-builder/${item._id}`)}
            style={{ cursor: "pointer" }}
          >
            <RiFileTextLine className={styles.fileIcon} color="#4F46E5" />
            <div className={styles.titleText}>
              <div>{item.title}</div>
              <small className={styles.date}>{item.date}</small>
            </div>
          </div>
        ),

        status: (
          <div className={styles.status}>
            <span className={styles.greenDot}></span>
            Live
          </div>
        ),
        submission: item.submission,
        review: item.review,
        action: (
          <Action
            options={item.actions}
            onSelect={(opt) => console.log(`Selected ${opt} for ${item.title}`)}
          />
        ),
      };
    });
  };

  const headings = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            setSelectedIds(checked ? data.map((d) => d._id) : []);
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Title", accessor: "title" },
    { title: "Status", accessor: "status" },
    { title: "Pending Submission", accessor: "submission" },
    { title: "Pending Review", accessor: "review" },
    { title: "Action", accessor: "action" },
  ];

  const displayData = getColumnData(data);

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <div className={styles.createForm}>
          <Dropdown
            label="New Form"
            options={["Form", "Contract", "Delete Request"]}
            bgColor="rgba(240, 240, 240, 1)"
            borderRadius="10px"
            onChange={(selected) => {
              if (selected === "Form") {
                navigate("/forms/formbuilderpage");
              }
            }}
          />
        </div>

        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar placeholder="Search by name" />
            </div>
            <Dropdown
              label="All Status"
              options={["Live", "Inactive", "Draft"]}
              bgColor="rgba(240, 240, 240, 1)"
              borderRadius="10px"
            />
          </div>

          <div>
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headings}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default StudentForms;
